import { ProcessingBadge, type ProcessingBadgeProps } from '@saas-pages/shared/public/app-shell'
import { useT } from './I18nProvider'

type Props = Omit<ProcessingBadgeProps, 'label'>

const LABEL_KEY = {
  local: 'local',
  server: 'server',
  'local-first': 'localFirst',
} as const

const TITLE_KEY = {
  local: 'localTitle',
  server: 'serverTitle',
  'local-first': 'localFirstTitle',
} as const

export function LocalizedProcessingBadge({ title, ...props }: Props) {
  const t = useT()
  return (
    <ProcessingBadge
      {...props}
      label={t.badge[LABEL_KEY[props.variant]]}
      title={title ?? t.badge[TITLE_KEY[props.variant]]}
    />
  )
}
